import * as React from 'react';
import { Link, RouteComponentProps, BrowserRouter as Router, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Filters, Pagination, constants, KeolisSpinner, moment } from './common/commonExport';
import * as actions from "../actions/index";

import autoTable from 'jspdf-autotable';
const keolisLogo = require('../../../src/assets/images/KeolisLogo.png');


class PDFPrinting extends React.Component {
  constructor(props) {
    super(props);
    this.state = { // default state for component
      params: this.props.Params,
      pageNumberInput: '',
      printStatus: false,
      filterState: {}
    }
  }


   printSelectedData() {    

      const { getSelectedCheckedData,fetchDataToPrint } = this.props;
      let self = this;
      let selectedRows = getSelectedCheckedData(); 
         let filterObj =  {selectedRows};
   let fetchObj = {
    url:constants.actionUrls.GET_FRA_WORKDAY_DETAILS,    
    filterObj:filterObj
    };

   fetchDataToPrint(fetchObj, function(data){
       if(data){        
        self.printData(data);
         }                    
       });   

    }

    onPrintButtonclicked()
    {
      const { isSelectedData } = this.props; 
      if(isSelectedData && isSelectedData == true)
      {
        this.printSelectedData();
      }
      else
      {        
          this.printData(this.props.fraworkdays);
      }

    }


  printData(fraworkdays) { 
      import("jspdf").then(({ jsPDF }) => {
          let orientation = 'landscape', unit = 'pt';
          const doc = new jsPDF(orientation, unit);

          for (var i = 0; i < fraworkdays.length; i++) {
              if (i > 0) {
                  doc.addPage();
              }
              this.singlePage(doc, fraworkdays[i]);
          }

          doc.save('FRA_Report_' + fraworkdays[0].wdy_date + '_' + fraworkdays[0].demp_display_id + '.pdf');
      });


    
  }

  singlePage(doc, data) {
    let img = new Image();
    let heading = (data.row_num == "0" || data.row_num == undefined) ? 'Hours of Duty Record' : 'Amendment ' + data.row_num ;
    let doNotShowTimeCalc = data.IsAmendment == '0' && (data.wdy_certify_status.trim().toUpperCase() == 'U')
    && data.AllowAmendmentEdit == undefined ;
    doc.setFontSize(24);
    doc.setFont(undefined,undefined, "normal");
    doc.text(heading, 40, 50);

    img.src = keolisLogo;
    doc.addImage(img, 'PNG', 660, 20, 163.8, 34.80);

    //FIRST DATA
    autoTable(doc,{
      startY: 80,
      theme: 'plain',
      margin: { left: 500 },
      tableWidth: 250,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          { content: 'Assignment:', styles: { fontStyle: 'bold' } },
          { content: data.wdy_job_symbol || '' }
        ],
        [
          { content: 'Position:', styles: { fontStyle: 'bold' } },
          { content: data.job_class || '' }
        ],
        [
          { content: 'Previous Time Off Duty:', styles: { fontStyle: 'bold' } },
          { content: this.getPrevTimeOffDuty(data) }
        ],
        [
          { content: 'Assignment Type:', styles: { fontStyle: 'bold' } },
          { content: 'Type ' + (data.job_type || '') }
        ],
      ],
    });

    autoTable(doc,{
      startY: 80,
      theme: 'plain',
      tableWidth: 250,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          { content: 'Employee Name:', styles: { fontStyle: 'bold' } },
          { content: data.emp_full_name }
        ],
        [
          { content: 'Employee ID:', styles: { fontStyle: 'bold' } },
          { content: data.demp_display_id }
        ],
        [
          { content: 'Date of Record:', styles: { fontStyle: 'bold' } },
          { content: data.wdy_date }
        ],
        [
          { content: '' },
          { content: '' }
        ],
        [
          { content: 'First Day in Series:', styles: { fontStyle: 'bold' } },
          { content: this.getFirstDayInSeries(data) }
        ],
        [
          { content: 'Day in Series:', styles: { fontStyle: 'bold' } },
          { content: data.dty_act_series_6 || '' }
        ]
      ],
    });

    ///
    
      autoTable(doc,{
      startY: 162,
      theme: 'plain',
      margin: { top: 0 },
      tableWidth: 300,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          { content: 'Previous Day Not Initiating Covered Service', styles: { fontStyle: 'bold' } },
          { content: data.previous_Non_CoveredService_date }
        ],
      ],
    });

    // doc.table(50, 20, [{test: 1}]);
    let dutyActivities = [];
    data.duty_activity.map(function (activity, index) {
      dutyActivities.push({
        line: index + 1,
        activity: activity.acivity_alias_name || activity.dty_act_name,
        start_datetime: activity.dty_act_start_date_time,
        start_location: activity.dty_act_start_place,
        end_datetime: doNotShowTimeCalc?"": activity.dty_act_end_date_time,
        end_location: doNotShowTimeCalc?"": activity.dty_act_end_place,
      });
    });

    
      autoTable(doc,{
      // theme: 'plain',
      styles: { lineWidth: 1, lineColor: [255, 255, 255], textColor: [0, 0, 0], fontSize: 10 },
      margin: { top: 60 },
      alternateRowStyles: { fillColor: [219, 219, 219] },
      bodyStyles: { fillColor: [237, 237, 237] },
      headStyles: { fillColor: [165, 165, 165], textColor: [255, 255, 255], },
      columnStyles: { 0: { fillColor: [165, 165, 165], textColor: [255, 255, 255], fontStyle: 'bold' } },
      body: dutyActivities,
      columns: [
        { header: 'LINE', dataKey: 'line' },
        { header: 'ACTIVITY', dataKey: 'activity' },
        { header: 'START DATE/TIME', dataKey: 'start_datetime' },
        { header: 'START LOCATION', dataKey: 'start_location' },
        { header: 'END DATE/TIME', dataKey: 'end_datetime' },
        { header: 'END LOCATION', dataKey: 'end_location' },
      ],
    });

    
      autoTable(doc,{
      // startY: 40,
      theme: 'plain',
      margin: { top: 150 },
      // tableWidth: 250,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          {
            content: 'Remarks: \n' + (this.getComment(data.wdy_comments) || ''),
            rowSpan: 3,
            styles: {
              halign: 'left',
              lineWidth: 1,
              lineColor: [0, 0, 0],
              cellPadding: 10,
              minCellHeight: 100
            }
          }
        ],
      ],
    });

    //TOTAL TABLE
    
      autoTable(doc,{
      theme: 'plain',
      margin: { top: 60 },
      tableWidth: 250,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          { content: 'Total TOD:', styles: { halign: 'left', fontStyle: 'bold' } },
          { content: doNotShowTimeCalc?"": this.getTotalTOD(data), styles: { halign: 'left' } }
        ],
        [
          { content: 'Relieved:', styles: { halign: 'left', fontStyle: 'bold' } },
          { content: doNotShowTimeCalc?"":this.getRelieved(data), styles: { halign: 'left' } }
        ],
        [
          { content: 'Final Release:', styles: { halign: 'left', fontStyle: 'bold' } },
          { content: doNotShowTimeCalc?"":this.getFinalRelease(data), styles: { halign: 'left' } }
        ],
      ],
    });

    //SIgnatire
    
      autoTable(doc,{
      // startY: 40,
      theme: 'plain',
      margin: { top: 150 },
      // tableWidth: 250,
      styles: { cellPadding: 1, fontSize: 10 },
      body: [
        [
          { content: 'Certified Employee Id:', styles: { halign: 'left', fontStyle: 'bold' } },
          { content: data.certify_by_id || '', styles: { halign: 'left' } }
        ],
        [
          { content: 'Employee Certification:', styles: { halign: 'left', fontStyle: 'bold' } },
          { content: data.Created_By || '', styles: { halign: 'left' } }
        ],
        [
          { content: 'Certification Date/Time:', styles: { halign: 'left', fontStyle: 'bold', cellWidth: 130 } },
          { content: ( data.Created_DateTime ? moment(data.Created_DateTime).format('MM/DD/YYYY hh:mm A') : data.wdy_certify_date) || '', styles: { halign: 'left' } }
        ],
      ],
    });
  }

  getComment(comment){
    if(comment){
      return comment.substring(
        comment.lastIndexOf("-") + 1, 
        comment.lastIndexOf("~")
      )
    }
    else{
      comment;
    }
  }

  getPrevTimeOffDuty(workday) {
    if(!Array.isArray(workday.duty_activity) 
      || workday.duty_activity.length == 0 
      || workday.prev_wdy_date == ''
      || workday.prev_wdy_spread == ''
      || workday.prev_wdy_time_end == ''
      || workday.prev_wdy_time_start == ''){
      return '-';//workday.wdy_previous_time_off;
    }
    
    if(workday.previous_Time_Off_Duty && workday.previous_Time_Off_Duty.length > 0) {return workday.previous_Time_Off_Duty;}
    


    //Set current date data
    let startDateTime = workday.wdy_date+" "+workday.duty_activity[0].dty_act_start_time;
    startDateTime = moment(startDateTime);

    let prevWorkDateTime = moment(workday.prev_wdy_time_end);
    if(moment(workday.prev_wdy_time_end).isValid()){
      prevWorkDateTime = moment(workday.prev_wdy_time_end);
    } else {
      let endDate = workday.prev_wdy_date;
      let endTime = workday.prev_wdy_time_end;
      let endSplit = endTime.split(':');
      let hr = endSplit.length > 0 ? endSplit[0] : 0;
      let mins = endSplit.length > 1 ? endSplit[1] : 0;
      if(hr > 24){
          endDate = moment(workday.prev_wdy_date , "YYYY-MM-DD").add('day', 1);
          hr = hr - 24;
      } 
      endDate = moment(endDate).add('h', hr);
      endDate = moment(endDate).add('m', mins);
      prevWorkDateTime = endDate;
    }
    let diff = startDateTime.diff(prevWorkDateTime);
    if(Number.isNaN(diff)){
      return '-';
    }
    var minutes = Math.floor(diff / 60000);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60
    var days = Math.floor(hours / 24);
    if(hours > 24)
    {
      hours = hours % 24;
    }
    let durationString = days > 0 ? days+'D ':'';
    durationString += hours+'H ';
    durationString += minutes+'M ';
    return durationString;
  }

  getFirstDayInSeries(workday){
    if(!workday.dty_act_series_6){
      return '';
    }

    let workDate = moment(workday.wdy_date, 'MM/DD/YYYY');
    workDate = workDate.subtract(workday.dty_act_series_6, "days");
    return workDate.format('MM/DD/YYYY')
  }

  getTotalTOD(workday) {

    let totalTOD ='';
    if(workday.total_time_hos &&  workday.total_time_hos.length>0 )
   {
    totalTOD = workday.total_time_hos.toLowerCase();
   } else
   {
    totalTOD = workday.wdy_working_time_hos_adjust || '' ;
   }

    return workday.IsPaydetail == 1 ? workday.wdy_working_time_hos || '' : totalTOD;
  }

  getRelieved(workday) {
    let signon = workday.duty_activity.filter((act) => !act.dty_act_name.includes("Deadhead") && !act.dty_act_name.toLowerCase().includes("limbo") && !act.dty_act_name.toLowerCase().includes('split break'));
  
    if(workday.relieved_Of_Duty &&  workday.relieved_Of_Duty.length>0 && signon && signon.length > 0 )
    {
      return workday.wdy_date + ' ' + signon[signon.length - 1].dty_act_end_place + ' ' + workday.relieved_Of_Duty;
    }else if (signon && signon.length > 0) {
      return workday.wdy_date + ' ' + signon[signon.length - 1].dty_act_end_place + ' ' + moment(signon[signon.length - 1].dty_act_end_time, "hh:mm A").format('hh:mm A');
    }

    return '';
  }

  getFinalRelease(workday) {

    if(workday.final_Release &&  workday.final_Release.length>0 && workday.duty_activity && workday.duty_activity.length > 0)
    {
      return workday.wdy_date + ' ' + workday.duty_activity[workday.duty_activity.length - 1].dty_act_end_place + ' ' + workday.final_Release;
    } else if(workday.duty_activity && workday.duty_activity.length > 0) {
      let activity = workday.duty_activity[workday.duty_activity.length - 1];
      return workday.wdy_date + ' ' + activity.dty_act_end_place + ' ' + moment(activity.dty_act_end_time, "HH:mm A").format('hh:mm A');
    }

    return '';
  }



  render() {
    const { printStatus } = this.props.printState;
    let isSelectedData= this.props.isSelectedData;
    
    let hidden = this.props.hidden;
    return (
      <div className={"printContainer " + (printStatus || hidden ? 'hidden' : '')}>
        <button className={"btn btnWidth btn-primary filterBtn"} onClick={this.onPrintButtonclicked.bind(this)}>{ (isSelectedData && isSelectedData==true)? 'Pdf':'Print'} <i className={(isSelectedData && isSelectedData==true)? "fa fa-file-pdf-o":"fa fa-print"} aria-hidden="true"></i></button>
        


      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    fraworkdays: state.FRA.fraworkdays,
    PaginationState: state.Pagination,
    filterState: state.filter,
    authDetails: state.authState,
    printState: state.printState,
    workday: state.workday.workday
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    printProgress: actions.printProgressAction,
    fetchDataToPrint: actions.fetchDataToPrintAction,
    onActErr: actions.actErrorAction
  }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(PDFPrinting);


